import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { RouteProps } from 'react-router';
import { useOauth2Principal } from '../oauth2.hooks';
import Spinner from '../../components/loading/spinner';

type Props = Omit<RouteProps, 'component'> & {
  readonly component: React.ComponentType<RouteProps & { module?: React.ReactElement }>;
  readonly subComponent?: React.ComponentType;
};

const Oauth2ProtectedRoute = ({
  component: Component,
  subComponent: SubComponent,
  ...rest
}: Props) => {
  const { isAuthenticated } = useOauth2Principal();

  if (isAuthenticated == null) {
    return <Spinner />;
  }

  return (
    <Route
      {...rest}
      render={props => {
        if (isAuthenticated) {
          if (SubComponent) {
            return <Component {...props} module={<SubComponent />} />;
          }
          return <Component {...props} />;
        }
        return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
      }}
    />
  );
};

export default Oauth2ProtectedRoute;
